














import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class RouterInfoTabs extends Vue {
  @Prop({ type: Array, default: [] }) links!: string[];

  active = this.links[0];

  @Watch("$route.name")
  changeActive(): void {
    for (const link of this.links) {
      if (this.$route.name == link) {
        this.active = link;
      }
    }
  }
}
